import React, {useState} from 'react';

import {ButtonRaw} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import InfoPopup from '@/components/Popup/InfoPopup';
import appContent from '@/services/content/appContent';

const RemainingSticksInfoIcon = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const {remainingSticksIcon, remainingSticksPopup} = appContent.getDeviceStatusContent();

    if (!remainingSticksPopup) return null;

    const {title, description, primaryButton, icon} = remainingSticksPopup;
    const closePopup = () => setIsPopupOpen(false);

    return (
        <>
            <ButtonRaw onClick={() => setIsPopupOpen(true)}>
                <RemoteIconV2 icon={remainingSticksIcon} className='h-4 w-4 shrink-0' />
            </ButtonRaw>
            {isPopupOpen && (
                <InfoPopup
                    icon={icon}
                    onClose={closePopup}
                    title={title}
                    description={description}
                    primaryButton={{
                        ...primaryButton,
                        onClick: closePopup,
                    }}
                />
            )}
        </>
    );
};

export default RemainingSticksInfoIcon;
